import Reporting_custom from './Reporting_custom'

export default Reporting_custom;
